import { environment } from '../environments/environment';

import { ChassisCoreModule } from '@kaiser-software/chassis-core';
import { ChassisCommentsModule } from '@kaiser-software/chassis-comments';
import { DonnaCoreModule } from '@kaiser-software/donna-core';
import { EyeWatchModule } from './eyewatch/eyewatch.module';

export const Modules = [
    ChassisCoreModule.forRoot(environment),
    ChassisCommentsModule,
    DonnaCoreModule,
    EyeWatchModule
];



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/modules.ts